import { createReducer } from '@reduxjs/toolkit';
import { EventListItemDTO } from 'src/common/models/event';
import { courseBundleEventsActions } from './courseBundleEventsActions';

export interface CourseBundleEventsState {
  items: EventListItemDTO[];
  total: number;
}

const initialState: CourseBundleEventsState = {
  items: [],
  total: 0,
};

export const courseBundleEventsReducer = createReducer<CourseBundleEventsState>(
  initialState,
  (builder) =>
    builder
      .addCase(courseBundleEventsActions.addEvents, (state, action) => {
        state.items.push(...action.payload);
      })
      .addCase(courseBundleEventsActions.clear, () => initialState)
      .addCase(courseBundleEventsActions.setEvents, (state, action) => {
        state.items = action.payload;
      })
      .addCase(courseBundleEventsActions.setTotal, (state, action) => {
        state.total = action.payload;
      }),
);
